module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "hamburgerButton"
  }, [_c('img', {
    attrs: {
      "id": "menuButton",
      "src": require("../../../static/images/menu.svg")
    },
    on: {
      "click": _vm.toggleMenu
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('ul', [(_vm.hash == 'home') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#home'),
      expression: "'#home'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Home")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#home'),
      expression: "'#home'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Home")])]), _vm._v(" "), (_vm.hash == 'infos') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#infos'),
      expression: "'#infos'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Informations")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#infos'),
      expression: "'#infos'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Informations")])]), _vm._v(" "), (_vm.hash == 'staff') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#staff'),
      expression: "'#staff'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Our team")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#staff'),
      expression: "'#staff'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Our team")])]), _vm._v(" "), (_vm.hash == 'philosophy') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#philosophy'),
      expression: "'#philosophy'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Philosophy")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#philosophy'),
      expression: "'#philosophy'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Philosophy")])]), _vm._v(" "), (_vm.hash == 'servicesHome') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#servicesHome'),
      expression: "'#servicesHome'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Services")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#services'),
      expression: "'#services'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Services")])]), _vm._v(" "), (_vm.hash == 'contactUs') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#contactUs'),
      expression: "'#contactUs'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Contact us")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#contactUs'),
      expression: "'#contactUs'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Contact us")])]), _vm._v(" "), (_vm.hash == 'order') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#order'),
      expression: "'#order'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Order")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#order'),
      expression: "'#order'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Order")])])])]), _vm._v(" "), (_vm.menuOpen) ? _c('div', {
    staticClass: "menuMobile"
  }, [_c('ul', [(_vm.hash == 'home') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#home'),
      expression: "'#home'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Home")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#home'),
      expression: "'#home'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Home")])]), _vm._v(" "), (_vm.hash == 'infos') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#infos'),
      expression: "'#infos'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Informations")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#infos'),
      expression: "'#infos'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Informations")])]), _vm._v(" "), (_vm.hash == 'staff') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#staff'),
      expression: "'#staff'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Our team")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#staff'),
      expression: "'#staff'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Our team")])]), _vm._v(" "), (_vm.hash == 'philosophy') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#philosophy'),
      expression: "'#philosophy'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Philosophy")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#philosophy'),
      expression: "'#philosophy'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Philosophy")])]), _vm._v(" "), (_vm.hash == 'servicesHome') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#servicesHome'),
      expression: "'#servicesHome'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Services")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#services'),
      expression: "'#services'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Services")])]), _vm._v(" "), (_vm.hash == 'contactUs') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#contactUs'),
      expression: "'#contactUs'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Contact us")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#contactUs'),
      expression: "'#contactUs'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Contact us")])]), _vm._v(" "), (_vm.hash == 'order') ? _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#order'),
      expression: "'#order'"
    }],
    staticClass: "activeLink",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Order")])]) : _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#order'),
      expression: "'#order'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Order")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "close"
    },
    on: {
      "click": _vm.toggleMenu
    }
  }, [_vm._v("Close menu")])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "homeContainer"
  }, [_c('h1', [_vm._v("Welcome to Vetopas ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dcb7d4c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/En/Home.vue
// module id = 152
// module chunks = 0